import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./core/styling/index.scss";
import "./assets/fonts/custom.font.css";
import Modal from "react-modal";
import App from "./views/App";

// Make sure to set your app element for accessibility (e.g., the root app div)
Modal.setAppElement("#root");
ReactDOM.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <App /> {/* Render your App component here */}
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
